import { IApplicationState } from '../../types/redux';

export function getIsSalesLeader(state: IApplicationState) {
  const {
    newbuilding: { isSalesLeader },
  } = state;

  return isSalesLeader;
}

export function getSalesLeaderUrl(state: IApplicationState) {
  const {
    newbuilding: { salesLeaderFullUrl },
  } = state;

  return salesLeaderFullUrl;
}
